import './highlightOverlay.css';

export default function() {
  const background = document.createElement('div');
  background.className = 'highlight-overlay';
  background.addEventListener('click', () => {
    background.remove();
  });
  document.body.appendChild(background);

  // Add the open class, wait and then remove it before
  // removing the element itself. The timeouts here are
  // related to the 1s transition time.
  window.setTimeout(() => {
    background.classList.add('open');
    window.setTimeout(() => {
      background.classList.remove('open');
      window.setTimeout(() => {
        background.remove();
      }, 1200);
    }, 1500);
  }, 0);
}
